import React, { FC } from 'react';
import { animated } from '@react-spring/web';
import styled from '@xstyled/styled-components';
import { useSlide } from '~/lib/transitions/useSlide';
import { Overlay } from '../overlay/Overlay';
import { AnyStyledComponent } from 'styled-components';

const AnimatedDiv = animated.div as AnyStyledComponent;
const Container = styled(AnimatedDiv)`
  position: absolute;
  top: 0;
  bottom: 0;
  background: ${p => p.theme.colors.white};
  box-shadow: 0 0 10px #000;
  z-index: ${p => p.theme.zIndices.dialogs};
`;

const Left = styled(Container)`
  left: 0;
`;

const Right = styled(Container)`
  right: 0;
`;

export const SlideOut: FC<{
  side: 'left' | 'right';
  open: boolean;
  overlayClicked?: () => void;
}> = ({ open, side, overlayClicked, children }) => {
  const transition = useSlide(open, side);
  return (
    <Overlay open={open} onClick={overlayClicked}>
      {transition(
        (styles, item) =>
          item &&
          (side === 'left' ? (
            <Left style={styles} onClick={(e: React.MouseEvent) => e.stopPropagation()}>
              {children}
            </Left>
          ) : (
            <Right style={styles} onClick={(e: React.MouseEvent) => e.stopPropagation()}>
              {children}
            </Right>
          ))
      )}
    </Overlay>
  );
};
